import { render, staticRenderFns } from "./FillAlignmentPaginationNav.vue?vue&type=template&id=31a60cff"
import script from "./FillAlignmentPaginationNav.vue?vue&type=script&lang=js"
export * from "./FillAlignmentPaginationNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports